var styleDataHash = "6598fcfd";
const injectCss = () => {
  var css = `.W8dvB,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._6EsEc{--ricos-custom-p-font-size:14px;align-items:center;color:var(--ricos-custom-p-color,unset);display:flex;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);letter-spacing:var(--ricos-custom-p-letter-spacing,unset);line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);padding-inline:16px;text-decoration:var(--ricos-custom-p-text-decoration,unset)}[dir] ._6EsEc{text-align:center}[dir] ._6EsEc>span>a,[dir] ._6EsEc>span>span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:640px){._6EsEc{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 640px){._6EsEc{font-size:var(--ricos-custom-p-font-size,unset)}}.UUVcn{margin-inline-start:-8px;position:absolute}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var caption_default = {
  "fontElementMap": "W8dvB",
  "caption": "_6EsEc",
  "aiButtonContainer": "UUVcn"
};
export {
  caption_default as default,
  injectCss
};
//# sourceMappingURL=caption-scss.js.map
